import React, { Fragment, useState } from 'react';
import Header from '../../components/Header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/business/Footer/Footer';
import Bg from '../../images/backgrounds/onze_diensten_image.webp';
import srImg from '../../images/services/quickscan/quickscan_info.webp';
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "reactstrap";
import CtaSection from "../../components/CtaSection/CtaSection";

const steps = [
    {
        id: 1,
        title: "Innovatie stimuleren",
        description: "Scale-ups zijn de motor van innovatie. Door u te ondersteunen, dragen wij bij aan nieuwe technologieën en ideeën die de wereld vooruithelpen.",
    },
    {
        id: 2,
        title: "Impact maken",
        description: "Het beschermen van snelgroeiende bedrijven heeft een directe impact. Een cyberaanval kan rampzalig zijn voor een scale-up, en wij willen dat voorkomen.",
    },
    {
        id: 3,
        title: "Flexibiliteit en groei",
        description: "Wij zijn gespecialiseerd in het bieden van flexibele oplossingen die meegroeien met uw bedrijf en uw toekomstige uitdagingen aankunnen.",
    },
];

const ScaleUp = (props) => {


    const [activeStep, setActiveStep] = useState(1);

    const handleStepClick = (stepId) => {
        setActiveStep(stepId);
    };

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <PageTitle pageTitle={'Waarom richten wij ons op Scale-Ups?'} bgImage={Bg} />
                <section className="about_section section_space bg-light">
                    <div className="container">
                        <div className="row align-items-center justify-content-lg-between">
                            <div className="col-lg-5 order-lg-first">
                                <div className="team_cartoon_image">
                                    <img src={srImg} alt="Service Cartoon"/>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="sectoren_content">
                                    <div className="heading_block">
                                        <h2 className="heading_text">
                                            Cybersecurity en Compliance voor snelgroeiende bedrijven
                                        </h2>
                                        <p className="heading_description mb-0">
                                            Scale-ups zitten in een unieke fase: uw bedrijf groeit snel, uw team breidt zich uit, en de vraag naar uw product of dienst blijft stijgen. Maar met groei komt ook complexiteit, vooral op het gebied van cybersecurity en compliance. Bij Praeventor begrijpen we dat u zich liever richt op innovatie en uitbreiding, terwijl wij ervoor zorgen dat uw digitale beveiliging en naleving van regelgeving op orde zijn.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="pt-130"></div>

                {/* Focusgebieden */}
                <section className="section_space bg-white">
                    <div className="container">
                        <h3 className="text-center mb-5">De uitdagingen van Scale-Ups</h3>
                        <p className="heading_description mb-5 pb-80">
                            Onze keuze om ons op scale-ups te richten is gebaseerd op de specifieke obstakels waar deze snelgroeiende bedrijven tegenaan lopen:
                        </p>
                        <div className="partners_faq accordion" id="partners_faq">
                            <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="1">
                                        Snelle groei vraagt om schaalbare oplossingen
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="1" className="acc_body">
                                            <p>
                                                Scale-ups groeien vaak sneller dan hun IT-infrastructuur aankan, wat kan leiden tot beveiligingslekken en inefficiënte processen.
                                            </p>
                                        </AccordionBody>
                                    </div>
                                </AccordionItem>

                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="2">
                                        Toenemende cyberrisico's
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="2" className="acc_body">
                                            <p>
                                                Naarmate uw bedrijf groeit, trekt u meer aandacht van hackers. Phishing-aanvallen, ransomware en datalekken kunnen grote schade toebrengen aan uw reputatie en groei.
                                            </p>
                                        </AccordionBody>
                                    </div>
                                </AccordionItem>

                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="3">
                                        Complexe regelgeving
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="3" className="acc_body">
                                            <p>
                                                Grotere klanten en markten brengen vaak strengere eisen met zich mee, zoals het voldoen aan AVG (GDPR), ISO 27001, en andere branche-specifieke standaarden.
                                            </p>
                                        </AccordionBody>
                                    </div>
                                </AccordionItem>

                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="4">
                                        Tijdgebrek bij teams
                                    </AccordionHeader>
                                    <div className="accordion-body-container">
                                        <AccordionBody accordionId="4" className="acc_body">
                                            <p>
                                                Uw team werkt aan het uitbreiden van uw marktpositie, maar heeft vaak niet de tijd of expertise om zich te verdiepen in cybersecurity en compliance.
                                            </p>
                                        </AccordionBody>

                                    </div>
                                </AccordionItem>
                            </Accordion>
                        </div>
                    </div>
                </section>

                {/*  Waarom kiezen bedrijven voor ons?  */}
                <section className="about_section section_space bg-light">
                    <div className="container">
                        <div className="row align-items-center justify-content-lg-between" style={{ padding: "100px"}}>
                            <div className="col-lg-12">
                                <div className="sectoren_content">
                                    <div className="heading_block">
                                        <h2 className="heading_text text-center">
                                            Waarom kiezen Scale-Ups voor Praeventor?
                                        </h2>
                                        <p className="heading_description mb-0 text-center">
                                            Wij richten ons op scale-ups omdat wij begrijpen dat beveiliging en compliance geen rem mogen zijn op groei. Ons doel is om oplossingen te bieden die naadloos meegroeien met uw organisatie, zodat u zich kunt concentreren op innovatie en succes.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="process_technology_review_section section_decoration">
                    <div className="container">
                        <div className="heading_block mb-5">
                            <h2 className="heading_text mb-0">
                                Wat maakt <mark>Scale-Ups</mark> aantrekkelijk voor ons?
                            </h2>
                        </div>

                        <div className="steps_container">
                            {steps.map((step, index) => (
                                <div
                                    key={step.id}
                                    className={`step_item ${activeStep === step.id ? 'active' : ''}`}
                                    onClick={() => handleStepClick(step.id)}
                                    style={{
                                        backgroundColor: activeStep === step.id ? '#f0f0f5' : 'white',
                                        border: '1px solid #e0e0e0',
                                        padding: '20px',
                                        marginBottom: '20px',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.3s ease',
                                    }}
                                >
                                    <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#2c3e50' }}>
                                        {`${step.id}. ${step.title}`}
                                    </div>
                                    <div style={{ marginTop: '10px', color: '#555' }}>
                                        {activeStep === step.id && <p>{step.description}</p>}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
                <CtaSection />
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default ScaleUp;
